import $ from 'jquery';

class SlickSliderController {
    constructor(wrapper, controls, autoplay = true, autoplaySpeed, slidesToShowDesktop, slidesToShowTablet, slidesCount,
        slidesToScrollDesktop = slidesToShowDesktop, slidesToScrollTablet = slidesToShowTablet, infinite = true, rtl = false) {
        this.wrapper = wrapper;
        this.controls = controls;

        this.slidesCount = slidesCount;

        this.slidesToScrollDesktop = slidesToScrollDesktop;
        this.slidesToScrollTablet = slidesToScrollTablet;

        this.slidesToShowDesktop = slidesToShowDesktop;
        this.slidesToShowTablet = slidesToShowTablet;

        this.infinite = infinite;
        this.autoplay = autoplay;
        this.autoplaySpeed = autoplaySpeed;
        this.rtl = rtl;

        this.hideArrowsOnDesktop = false;
        this.hideArrowsOnTablet = false;
        this.hideArrowsOnPhone = false;

        this.prepareSlider();
    }

    setSliderArrowPosition() {
        if (this.hideArrowsOnDesktop) {
            $(this.controls).addClass('hidden-lg');
        }
        if (this.hideArrowsOnTablet) {
            $(this.controls).addClass('hidden-sm');
        }
        if (this.hideArrowsOnPhone) {
            $(this.controls).addClass('hidden-xs');
        }
        if (!(this.hideArrowsOnDesktop && this.hideArrowsOnTablet && this.hideArrowsOnPhone)) {
            const sliderTrackHeight = $(this.wrapper).find('.slick-track').first().height();
            const arrowHeight = $(this.controls).find('.prev').first().height();
            const captions = $(this.wrapper).find('.slick-track figcaption');
            if (captions.length) {
                let capHeight = 0;
                $.each(captions, (i, v) => {
                    if (capHeight < v.clientHeight) capHeight = v.clientHeight;
                });
                $(this.controls).find('prev', 'next').attr('style', `top:-${capHeight}px !important;`);
            }
            else {
                const midPoint = `${(sliderTrackHeight / 2) - (arrowHeight / 2)}px`;
                $(this.controls).css('top', midPoint);
            }
        }
    }

    /* eslint no-param-reassign: ["error", { "props": false }] */
    prepareSlider() {
        this.hideArrowsOnDesktop = this.slidesCount <= this.slidesToShowDesktop;
        this.hideArrowsOnTablet = this.slidesCount <= this.slidesToShowTablet;
        this.hideArrowsOnPhone = this.slidesCount <= 1;

        $(this.wrapper).slick({
            autoplay: this.autoplay,
            autoplaySpeed: this.autoplaySpeed,
            dots: true,
            appendDots: this.controls,
            pauseOnHover: true,
            pauseOnDotsHover: true,
            slide: '',
            prevArrow: this.controls.children[0],
            nextArrow: this.controls.children[1],
            slidesToShow: this.slidesToShowDesktop,
            slidesToScroll: this.slidesToScrollDesktop,
            infinite: this.infinite,
            rtl: this.rtl,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: this.slidesToShowTablet,
                        slidesToScroll: this.slidesToScrollTablet,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
        $(`#${this.controls.id} .next`).before($(`#${this.controls.id} .slick-dots`));
        this.setSliderArrowPosition();
    }

    static init(slickWrapper, slickControls, autoplay, autoplaySpeed, slidesToShowDesktop, slidesToShowTablet, slidesCount,
        slidesToScrollDesktop, slidesToScrollTablet, infinite, rtl) {
        new SlickSliderController(slickWrapper, slickControls, autoplay, autoplaySpeed, slidesToShowDesktop, slidesToShowTablet, slidesCount,
            slidesToScrollDesktop, slidesToScrollTablet, infinite, rtl); // eslint-disable-line no-new
    }
}

window.SlickSliderController = SlickSliderController;
export default SlickSliderController;
